import { render, staticRenderFns } from "./take-palm-two.vue?vue&type=template&id=43323ec4&scoped=true"
import script from "./take-palm-two.vue?vue&type=script&lang=ts"
export * from "./take-palm-two.vue?vue&type=script&lang=ts"
import style0 from "./take-palm-two.vue?vue&type=style&index=0&id=43323ec4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43323ec4",
  null
  
)

export default component.exports